import React from "react";
import { useNavigate } from "react-router-dom";

const GoToDashboardButton = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate("/")}
      type="button"
      className="px-6 py-3 bg-blue-600 text-white rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      <i className="fas fa-home mr-2"></i>
      Go to Dashboard
    </button>
  );
};

export default GoToDashboardButton;
